module.exports = __webpack_public_path__ + "static/img/baobiaotongji.fc5bf13.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baobiaotongji.gif
// module id = 1e27
// module chunks = 1